import {createApp} from 'vue';
import App from './App.vue';
import router from './router'; // 引入路由配置
import type { LocationQuery, RouteParamsRaw } from 'vue-router'
import {createPinia} from 'pinia'; // 引入Pinia
import ElementPlus from 'element-plus'; // 引入Element Plus
import 'element-plus/dist/index.css'; // 引入Element Plus样式
import {createI18n} from 'vue-i18n'; // 引入Vue I18n
// 导入核心公共样式
import '@/assets/css/main.css'  // 全局样式
import '@/assets/css/element-overrides.scss'
import '@/assets/css/common.scss'
import {themeManager} from './theme/theme-manager'


// 在创建app之前初始化主题
themeManager.updateTheme({
    primary: '#0A1A2F'
})
// import messages from './locales'; // 假设你有语言包文件

// 创建Pinia实例
const pinia = createPinia();

// 创建i18n实例
const i18n = createI18n({
    locale: 'en', // 设置默认语言
    fallbackLocale: 'zh', // 设置备用语言
    // messages, // 语言包
});

type NavigationParams = {
  query?: LocationQuery
  params?: RouteParamsRaw
}

// 创建Vue应用实例
const app = createApp(App);

// 修正后的导航方法
app.config.globalProperties.$navigate = {
  path: (path: string, { query }: Omit<NavigationParams, 'params'> = {}) => {
    if (router.currentRoute.value.path !== path) {
      router.push({ path, query })
    }
  },
  name: (name: string, { params }: Omit<NavigationParams, 'query'> = {}) => {
    if (router.currentRoute.value.name !== name) {
      router.push({ name, params })
    }
  },
  back: (delta = -1) => router.go(delta)
}

// 使用插件
app.use(pinia); // 使用Pinia
app.use(router); // 使用Vue Router
app.use(ElementPlus); // 使用Element Plus
app.use(i18n); // 使用Vue I18n

// 挂载应用到DOM
app.mount('#app');
